/**
 * @generated SignedSource<<054a5a4eb45b570737e81ed83d6db785>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type Country = "CH" | "DE";
export type Gender = "FEMALE" | "MALE" | "OTHER" | "UNKNOWN";
import { FragmentRefs } from "relay-runtime";
export type patientSearchableTable$data = {
  readonly birthDate: string;
  readonly city: string | null;
  readonly compulsoryHealthInsuranceCardNumber: string | null;
  readonly compulsoryInsureeNumber: string | null;
  readonly compulsoryOrganisationName: string | null;
  readonly compulsoryPolicyNumber: string | null;
  readonly country: Country;
  readonly displayId: number;
  readonly firstName: string | null;
  readonly gender: Gender;
  readonly highlights: ReadonlyArray<{
    readonly key: string;
    readonly value: string;
  }> | null;
  readonly isPotentialDuplicate: boolean;
  readonly lastContactAt: string | null;
  readonly lastName: string | null;
  readonly patientId: string;
  readonly phoneNumber: string | null;
  readonly postalCode: string | null;
  readonly searchScore: number | null;
  readonly street: string | null;
  readonly supplementary1HealthInsuranceCardNumber: string | null;
  readonly supplementary1InsureeNumber: string | null;
  readonly supplementary1OrganisationName: string | null;
  readonly supplementary1PolicyNumber: string | null;
  readonly supplementary2HealthInsuranceCardNumber: string | null;
  readonly supplementary2InsureeNumber: string | null;
  readonly supplementary2OrganisationName: string | null;
  readonly supplementary2PolicyNumber: string | null;
  readonly supplementary3HealthInsuranceCardNumber: string | null;
  readonly supplementary3InsureeNumber: string | null;
  readonly supplementary3OrganisationName: string | null;
  readonly supplementary3PolicyNumber: string | null;
  readonly " $fragmentType": "patientSearchableTable";
};
export type patientSearchableTable$key = {
  readonly " $data"?: patientSearchableTable$data;
  readonly " $fragmentSpreads": FragmentRefs<"patientSearchableTable">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "patientSearchableTable",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "patientId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "country",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "firstName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "birthDate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "displayId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "phoneNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "city",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "street",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "postalCode",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "gender",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compulsoryOrganisationName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compulsoryHealthInsuranceCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compulsoryPolicyNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "compulsoryInsureeNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary1OrganisationName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary1HealthInsuranceCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary1PolicyNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary1InsureeNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary2OrganisationName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary2HealthInsuranceCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary2PolicyNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary2InsureeNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary3OrganisationName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary3HealthInsuranceCardNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary3PolicyNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplementary3InsureeNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isPotentialDuplicate",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "lastContactAt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "KeyValuePairOfStringAndString",
      "kind": "LinkedField",
      "name": "highlights",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "key",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "value",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "searchScore",
      "storageKey": null
    }
  ],
  "type": "PatientSearchResult",
  "abstractKey": null
};

(node as any).hash = "eb4c7e4fcaf01458d5eeee5e2064c249";

export default node;
